import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
import { axiosInstance } from "../utils/axiosInstance";
import { useNavigate } from "react-router-dom";

const ChangePassword = () => {
  // Define form validation schema using Yup
  const navigate = useNavigate();
  const validationSchema = Yup.object({
    currentPassword: Yup.string().required("Current password is required"),
    newPassword: Yup.string()
      .min(8, "New password must be at least 8 characters")
      .required("New password is required"),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("newPassword"), null], "Passwords must match")
      .required("Confirm password is required"),
  });

  // Initialize Formik
  const formik = useFormik({
    initialValues: {
      currentPassword: "",
      newPassword: "",
      confirmPassword: "",
    },
    validationSchema,
    onSubmit: async (values) => {
      try {
        const formData = new FormData();
        formData.append("current_password", values?.currentPassword);
        formData.append("password", values?.newPassword);
        formData.append("password_confirmation", values?.confirmPassword);
        const response = await axiosInstance.post(
          "user/change/password",
          formData
        );
        if (response?.data?.status === true) {
          toast.success(
            response?.data?.message ||
              "This Product Has Been Added In Your Favourite"
          );
          navigate("/userprofile");
        } else {
          toast.error(
            response?.data?.message || "Something went wrong, try again."
          );
        }
      } catch (error) {
        console.error("Error:", error);
        const errorMessage =
          error?.response?.data?.message || "An unexpected error occurred.";
        toast.error(errorMessage);
      }
    },
  });

  return (
    <div className="col-xl-12 wow fadeInUp" data-wow-duration="1s">
      <div className="dashboard_content">
        <div className="dashboard_body change_password">
          <div className="review_input">
            <h3>Change Password</h3>
            <div className="comment_input pt-0 mb-0">
              <form onSubmit={formik.handleSubmit}>
                <div className="row">
                  <div className="col-xl-6">
                    <div className="comment_imput_single">
                      <label htmlFor="currentPassword">Current Password</label>
                      <input
                        id="currentPassword"
                        name="currentPassword"
                        type="password"
                        placeholder="Current Password"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.currentPassword}
                      />
                      {formik.touched.currentPassword &&
                      formik.errors.currentPassword ? (
                        <div className="error_message text-red">
                          {formik.errors.currentPassword}
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className="col-xl-6">
                    <div className="comment_imput_single">
                      <label htmlFor="newPassword">New Password</label>
                      <input
                        id="newPassword"
                        name="newPassword"
                        type="password"
                        placeholder="New Password"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.newPassword}
                      />
                      {formik.touched.newPassword &&
                      formik.errors.newPassword ? (
                        <div className="error_message text-red">
                          {formik.errors.newPassword}
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className="col-xl-12">
                    <div className="comment_imput_single">
                      <label htmlFor="confirmPassword">Confirm Password</label>
                      <input
                        id="confirmPassword"
                        name="confirmPassword"
                        type="password"
                        placeholder="Confirm Password"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.confirmPassword}
                      />
                      {formik.touched.confirmPassword &&
                      formik.errors.confirmPassword ? (
                        <div className="error_message text-red">
                          {formik.errors.confirmPassword}
                        </div>
                      ) : null}
                    </div>
                    <button type="submit" className="common_btn mt_20">
                      Susbmit
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;
